module.exports = __webpack_public_path__ + "img/trust-feature-2.7b3771dc.svg";